import React from "react";
import { InputField } from "../../ServicePricing/components";
import {
  validateRegistration,
  validateVIN,
  isSubaruVin,
} from "../../../utils/CarDetailsValidator";
import Loader from "../../Loader";
import classNames from "classnames";
import ReactSelectWrap from "../../ReactSelectWrap";
import { ContentRecallImagePath } from "../../../utils/ContentMediaPath";
import { PopupModalNative } from "../../Modals";
import { PopupModalModel } from "../../../models/PopupModalModel";
import { ApiBasePath } from "../../../utils/ApiBasePath";
import * as Request from "superagent";
import StepNav from "../../StepNav";
import { enableBodyScroll } from "../../../utils/dom";

interface VehicleLookupProps {
  findCar: (vin) => void;
  stepNav: StepNav;
}

interface VehicleLookupState {
  regoNumber?: string;
  regoNumberError?: boolean;
  selectedState?: string;
  selectedStateError?: boolean;
  regoNumberErrorString?: string;
  vinNumber?: string;
  vinNumberError?: boolean;
  vinNumberErrorString?: string;
  showFindVinPopup: boolean;
  submitDisabled: boolean;
  showLoader: boolean;
  content: PopupModalModel;
  recaptchaToken: string | undefined;
  recaptchaServerFailed: boolean;
}

const content: PopupModalModel = {
  text: `<div>
<h3>Where do I find my VIN? (Vehicle Identification Number)</h3>
<p>
  The Vehicle Identification Number (VIN) can be found in a few places including on the the car's registration
  label, on the build plate in the engine bay or on the passenger side windshield and door jamb. It also
  appears on registration and insurance documents. Make sure you enter the VIN accurately, here are tips to
  make sure you have the right number:
</p>
<p>
  <img src="${ContentRecallImagePath}/takataRecall/wheres-my-vin.jpg" loading="lazy"/>
</p>
<h3>VIN Accuracy Tips</h3>
<ul>
  <li>The letters "I", "O", and "Q" never appear in a VIN</li>
  <li>The VIN must be exactly 17 characters in length.</li>
</ul>
</div>`,
};

const states = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"].map(
  (state) => {
    return { value: state, label: state };
  }
);

class vehicleLookup extends React.Component<
  VehicleLookupProps,
  VehicleLookupState
> {
  constructor(props: VehicleLookupProps) {
    super(props);

    const intialState = {
      regoNumber: "",
      regoNumberErrorString: "",
      regoNumberError: false,
      vinNumber: "",
      vinNumberErrorString: "",
      vinNumberError: false,
      showFindVinPopup: false,
      selectedState: "",
      selectedStateError: false,
      submitDisabled: true,
      showLoader: false,
      content: null,
      recaptchaToken: undefined,
      recaptchaServerFailed: false,
    };

    this.state = intialState;
    states.unshift({ value: "", label: "State" });

    //reseting form values on back button
    $(window).bind("pageshow", function () {
      (
        document.getElementById("vehicleLookupRecalls") as HTMLFormElement
      ).reset();
    });
  }

  componentDidMount() {
    window["validateRecallRecaptcha"] = this.validateRecaptcha;
  }

  private showVinModal(e?: any) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      showFindVinPopup: true,
      content: content,
    });

    this.close = this.close.bind(this);
  }

  close() {
    enableBodyScroll();
    this.setState({
      showFindVinPopup: false,
      content: null,
    });
  }

  handleRegoChange = ({ target: { value } }) => {
    const isError = validateRegistration(value);
    this.setState({
      regoNumberError: isError !== "",
      regoNumberErrorString: isError,
      regoNumber: !isError ? value : "",
      vinNumber: this.state.vinNumberError ? "" : this.state.vinNumber,
      vinNumberError: false,
      submitDisabled: isError !== "" || this.state.selectedState == "",
    });
  };

  handleVINChange = ({ target: { value } }) => {
    const isError = validateVIN(value);
    this.setState({
      vinNumberError: isError !== "",
      vinNumberErrorString: isError,
      vinNumber: !isError ? value : "",
      regoNumber: this.state.regoNumberError ? "" : this.state.regoNumber,
      regoNumberError: false,
      submitDisabled: isError !== "",
    });
  };

  handleStateChange = (target: any) => {
    this.setState({
      selectedState: target.value,
      selectedStateError: false,
      vinNumber: "",
      vinNumberError: false,
      submitDisabled: !this.state.regoNumberError
        ? !(this.state.regoNumber != "" && target.value != "")
        : true,
    });
  };

  findCarByVin = (vin) => {
    if (isSubaruVin(vin)) {
      this.props.findCar(vin);
    } else {
      this.props.stepNav.navigate();
    }
  };

  submitError = ({ status }) => {
    // vin not found
    if (status === 404) {
      this.props.stepNav.navigate();
    }

    // validation error
    else if (status === 429) {
      this.setState({
        recaptchaToken: undefined,
        recaptchaServerFailed: true,
        submitDisabled: false,
        showLoader: false,
      });

      window["grecaptcha"].reset();
    }
  };

  validateRecaptcha = (recaptchaToken: string | undefined) => {
    this.setState({ recaptchaToken });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    this.setState({
      showLoader: true,
      submitDisabled: true,
    });
    this.findCarByVin(this.state.vinNumber);
  };

  render() {
    const {
      regoNumber,
      regoNumberError,
      selectedState,
      selectedStateError,
      regoNumberErrorString,
      vinNumber,
      vinNumberError,
      vinNumberErrorString,
      showFindVinPopup,
      submitDisabled,
      showLoader,
      content,
      recaptchaToken,
      recaptchaServerFailed,
    } = this.state;
    const regoInputClass = classNames({
      text: true,
      textInputRego: true,
      pc__input: true,
      "pc__input--isLoading": false,
      "input-validation-error": regoNumberError,
    });
    const vinInputClass = classNames({
      text: true,
      textInputVin: true,
      pc__input: true,
      "pc__input--isLoading": false,
      "input-validation-error": vinNumberError,
    });

    return (
      <div>
        <div className="row">
          <h2 className="h3 text-center col-xs-12 col-md-12 col-lg-12">
            My Vehicle Details
          </h2>
        </div>
        <Loader isLoading={showLoader} isPositionRelative={false} />
        <form action="" method="post" id="vehicleLookupRecalls">
          <div className="row">
            <div className="col-12 col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4">
              <fieldset className="formFieldSet">
                <div>
                  Search by VIN{" "}
                  <a
                    className=" btn btn--text float-right"
                    onClick={() => this.showVinModal()}
                  >
                    Where's my VIN?
                  </a>
                </div>
                <InputField
                  label=""
                  className={vinInputClass}
                  name="Vin"
                  id="text-input-vin"
                  onChange={(e) => {
                    this.handleVINChange(e);
                  }}
                  onKeyUp={() => {}}
                  isDisabled={regoNumber.length > 0 || selectedState != ""}
                  isValidationError={vinNumberError}
                  validationErrorMessage={vinNumberErrorString}
                  requestErrorMessage="Sorry, we don’t recognise the vin you have entered."
                />
              </fieldset>
              <div className="row">
                <div className="col-xs-12 recall-recaptcha-wrapper">
                  <p>
                    Don’t own your Subaru anymore?{" "}
                    <a href="/update-my-details">click here</a>
                  </p>

                  <div
                    className="g-recaptcha"
                    data-sitekey="6LcD-CQjAAAAAP6Ey2v2uT1Tb1D3OEOiFPLS0Zr1"
                    data-expired-callback="validateRecallRecaptcha"
                    data-callback="validateRecallRecaptcha"
                  />
                  {recaptchaServerFailed && (
                    <p className="recaptcha-error">
                      Failed validating Google ReCaptcha. Please try again.
                    </p>
                  )}
                </div>
              </div>
              <div className="row recall-submit-btn-wrapper">
                <div className="col-sm-12 text-center">
                  <p>
                    <input
                      id="recall-vehicle-lookup"
                      type="submit"
                      className="btn  margin-top-20px"
                      value="Next Step"
                      onClick={(e) => {
                        this.onSubmit(e);
                      }}
                      disabled={submitDisabled || recaptchaToken === undefined}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </form>
        {showFindVinPopup ? (
          <PopupModalNative
            content={content}
            isVisible={showFindVinPopup}
            close={this.close}
          />
        ) : null}
      </div>
    );
  }
}

export default vehicleLookup;
